var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export const optimizeImage = (file, quality) => __awaiter(void 0, void 0, void 0, function* () {
    if (!file.type.includes('image')) {
        throw new Error('The provided file is not an image.');
    }
    if (quality < 0 || quality > 1) {
        throw new Error('Quality must be a number between 0 and 1.');
    }
    const imageUrl = URL.createObjectURL(file);
    const img = new Image();
    return new Promise((resolve, reject) => {
        img.onload = () => {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            if (!ctx) {
                reject(new Error('Canvas context is not available.'));
                return;
            }
            canvas.width = img.width;
            canvas.height = img.height;
            ctx.drawImage(img, 0, 0);
            canvas.toBlob((blob) => {
                if (blob) {
                    resolve(new File([blob], file instanceof File ? file.name : 'optimized_image', { type: file.type }));
                }
                else {
                    reject(new Error('Failed to optimize the image.'));
                }
            }, file.type, quality);
        };
        img.onerror = () => {
            reject(new Error('Failed to load the image.'));
        };
        img.src = imageUrl;
    });
});
